function getTime(time) {
    if (typeof time === 'number')
        return time;
    if (typeof time === 'string' && /([.\d]+)([DdSsHhMm])$/.test(time)) {
        var t = void 0;
        var value = +RegExp.$1;
        var format = RegExp.$2.toLocaleLowerCase();
        if (format === 'd') {
            t = value * 24 * 60 * 60 * 1000;
        }
        else if (format === 'h') {
            t = value * 60 * 60 * 1000;
        }
        else if (format === 'm') {
            t = value * 60 * 1000;
        }
        else if (format === 's') {
            t = value * 1000;
        }
        return Date.now() + t;
    }
    throw new Error('time must be number or string of valid format');
}

var VERSION = '1.1.0';
function createCache(api) {
    return {
        get: function (key, options) {
            if (options === void 0) { options = { version: VERSION, time: '7d' }; }
            var _a = options.version, version = _a === void 0 ? VERSION : _a;
            try {
                var item = api.getItem(key);
                if (item) {
                    var data = JSON.parse(item);
                    if (data && data.version === version) {
                        if (data.expires !== -1 && data.expires < Date.now()) {
                            this.remove(key);
                            return undefined;
                        }
                        return data.value;
                    }
                }
                return undefined;
            }
            catch (error) {
                return undefined;
            }
        },
        set: function (key, data, options) {
            if (options === void 0) { options = { version: VERSION, time: '7d' }; }
            var _a = options.version, version = _a === void 0 ? VERSION : _a, _b = options.time, time = _b === void 0 ? '7d' : _b;
            try {
                data = { version: version, value: data, expires: +getTime(time) };
                api.setItem(key, JSON.stringify(data));
                return true;
            }
            catch (error) {
                if (error.name === 'QuotaExceededError') {
                    this.clear();
                    return this.set(key, data, options);
                }
                return false;
            }
        },
        clear: function () {
            try {
                api.clear();
                return true;
            }
            catch (error) {
                return false;
            }
        },
        remove: function (key) {
            try {
                api.removeItem(key);
                return true;
            }
            catch (error) {
                return false;
            }
        },
        setItem: function (key, data) {
            api.setItem(key, data);
        },
        getItem: function (key) {
            return api.getItem(key);
        },
        removeItem: function (key) {
            api.removeItem(key);
        },
    };
}
var MemoryStorage = /** @class */ (function () {
    function MemoryStorage() {
        this.cache = {};
    }
    MemoryStorage.prototype.getItem = function (key) {
        if (key in this.cache) {
            return this.cache[key];
        }
        return null;
    };
    MemoryStorage.prototype.setItem = function (key, data) {
        this.cache[key] = data;
    };
    MemoryStorage.prototype.removeItem = function (key) {
        delete this.cache[key];
    };
    MemoryStorage.prototype.clear = function () {
        this.cache = {};
    };
    return MemoryStorage;
}());
var localCache;
var sessionCache;
if (typeof window === 'undefined') {
    var cache = {
        get: function () {
            return undefined;
        },
        set: function () { },
        clear: function () { },
        remove: function () { },
        getItem: function () { },
        setItem: function () { },
        removeItem: function () { },
    };
    localCache = cache;
    sessionCache = cache;
}
else {
    try {
        localCache = createCache(window.localStorage);
    }
    catch (error) {
        localCache = createCache(new MemoryStorage());
    }
    try {
        sessionCache = createCache(window.sessionStorage);
    }
    catch (error) {
        sessionCache = createCache(new MemoryStorage());
    }
}
var memoryCache = createCache(new MemoryStorage());

export { localCache, memoryCache, sessionCache };
